import { render } from "./create_client.vue?vue&type=template&id=301851d0&scoped=true"
import script from "./create_client.vue?vue&type=script&lang=js"
export * from "./create_client.vue?vue&type=script&lang=js"

import "./create_client.vue?vue&type=style&index=0&id=301851d0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-301851d0"]])

export default __exports__